<footer class="footer">
  <div class="footer__block footer__block--left">
    <img
      data-src="assets/images/national_emblem.png"
      class="footer__img lazyload"
      alt="Esculo Nacional"
    />
    <div class="footer__line"></div>
    <p>Gobierno del Perú</p>
    <div class="footer__line"></div>
    <p>Ministerio de Trabajo y Promoción del empleo</p>
    <div class="footer__line"></div>
    <p>Seguro Social de salud Essalud</p>
  </div>
  <div class="footer__block footer__block--right">
    <a
      class="footer__link"
      href="http://portal.essalud.gob.pe"
      rel="noopener noreferrer"
      target="__blank"
      >www.essalud.gob.pe</a
    >
    <div class="footer__line"></div>
    <p class="footer__group-text">
      <span>Sede Central: Av. Arenales N° 1402</span>
      <span>Jesús María, Lima 11 – Perú</span>
      <span>Teléfonos: (511)265-6000 / (511) 265-7000</span>
    </p>
  </div>
</footer>
